import apiPaths from '../api-paths';

export default {
  index() {
    return axios.get(`${ apiPaths.CRM }/unit-types`);
  },
};
